<template>
  <v-expansion-panels
    style="position: absolute; bottom: 0px; background: transparent"
  >
    <v-expansion-panel style="background: transparent">
      <v-expansion-panel-header>
        <v-row no-gutters align="center" justify="center">{{ $t('info') }}</v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <template v-for="(item, i) in orderInfo.info">
          <div class="text-center pt-2">
            {{ i }}: {{ item.message }}:
            <span
              :class="item.status === 'da' ? 'success' : 'warning'"
              class="px-1 white--text"
            >
              {{ item.status }}
            </span>
            <br />
            <div class="text-caption gray--text">{{ item.params }}</div>
          </div>
        </template>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  name: "PaymentInfoBox",
  props: {
    orderInfo: {
      type: Object,
      default: () => ({ info: [] }),
    },
  },
};
</script>
